module.exports = __webpack_public_path__ + "img/汽车天窗3.6e77b986.jpg";